// extracted by mini-css-extract-plugin
export default {"CommentListPlaceholder":"ih_a bhy_jk","CommentListPlaceholder--Legacy":"ih_b bhy_rc bhy_wq"};